import angular from 'angular'

/**
 * =======================================
 * Namespace modules
 * =======================================
 */
angular.module('vendQuickKeys', [])
angular.module('webregister.http', [])
angular.module('webregister.resolvers', [])
angular.module('webregister.routes', [])
angular.module('webregister.controllers', [])
angular.module('webregister.filters', [])
angular.module('webregister.directives', [])
angular.module('webregister.components', [])
angular.module('webregister.modals', [])
angular.module('webregister.factories', [])
angular.module('webregister.services', [])
angular.module('webregister.managers', [])
angular.module('webregister.vendor', [])

/**
 * =======================================
 * Initialise webregister application
 * =======================================
 */

angular.module('webregister', [
  'webregister.vendor',
  'webregister.http',
  'webregister.components',
  'webregister.resolvers',
  'webregister.routes',
  'webregister.filters',
  'webregister.factories',
  'webregister.managers',
  'webregister.controllers',
  'webregister.directives',
  'webregister.modals',
  'webregister.services',
])
